var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEquatorialGuinea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.826 166.957H496.076C459.906 69.472 366.07 0 256 0C185.306 0 121.313 28.659 74.9893 74.989L155.826 166.957Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.826 345.043H496.076C459.906 442.528 366.07 512 256 512C185.306 512 121.313 483.341 74.9893 437.011L155.826 345.043Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9795 74.98C-24.9945 174.954 -24.9945 337.045 74.9795 437.02C116.293 395.707 156.026 355.974 256 256L74.9795 74.98Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.522 211.478V267.13C300.522 301.21 345.044 311.653 345.044 311.653C345.044 311.653 389.566 301.21 389.566 267.13V211.478H300.522Z",
    fill: "#DEDDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.913 257.113H356.174V289.391H333.913V257.113Z",
    fill: "#786145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.304 244.87C367.304 232.575 357.338 222.609 345.043 222.609C332.748 222.609 322.782 232.575 322.782 244.87C316.635 244.87 311.652 249.853 311.652 256C311.652 262.147 316.635 267.13 322.782 267.13H367.304C373.451 267.13 378.434 262.147 378.434 256C378.434 249.853 373.452 244.87 367.304 244.87V244.87Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquatorialGuinea);
export default __webpack_public_path__ + "static/media/equatorialGuinea.585a22ba708a70019003ab7190ecd941.svg";
export { ForwardRef as ReactComponent };